import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

const CreateNewBtn = (props) => {
	return (
		<Row>
			<Col className="d-flex">
				<a
					className="viewPolicy-btn"
					href="https://teo1dk-portal1.sharepoint.com/HR%20Policies/Forms/AllItems.aspx"
					target="_blank"
					rel="noopener noreferrer"
					style={{ textDecoration: "none" }}
				>
					View Policies
				</a>
			</Col>
			<Col>
				<Link
					to={
						props.monthlyReimburse
							? "/monthlyReimbursement"
							: "/generalReimbursement"
					}
				>
					<input
						type="submit"
						value="Create New +"
						className="createNew-btn"
						onClick={props.btnClicked}
					/>
				</Link>
			</Col>
		</Row>
	);
};
export default CreateNewBtn;
